/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ExpandInputs */

const en_nav_expand = /** @type {(inputs: Nav_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand the sidebar`)
};

/**
* | output |
* | --- |
* | "Expand the sidebar" |
*
* @param {Nav_ExpandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_expand = /** @type {((inputs?: Nav_ExpandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ExpandInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_expand(inputs)
});